export default __webpack_public_path__ + "static/media/TermsAndConditions.82e701e4.pdf";